import { PropsWithChildren } from "react";
import { useParams, Outlet } from "react-router-dom";

import { BeamlineProvider } from './beamlineProvider.tsx';


// The only purpose of this component is to accept a Set slug as a url parameter
// and provide the corredponging ESAF slug to a SampleSetsProvider.
// It's so we can respond to urls like /set/:setSlug, in addition to the more standard
// /esaf/:esafSlug/set/:setSlug.

const ManageBeamline: React.FC<PropsWithChildren<{}>> = (props) => {

  let { beamlineSlug: beamlineSlugFromParams } = useParams();

  return (
      <BeamlineProvider beamlineSlug={beamlineSlugFromParams}>
        <Outlet />
      </BeamlineProvider>
  )
}

export default ManageBeamline